import { useState } from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import styles from './WhatsAppWidget.module.css';

const WhatsAppWidget = ({ phoneNumber, message = '', initialMessage = '' }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [inputMessage, setInputMessage] = useState(message);
  const [chatMessage, setChatMessage] = useState(initialMessage);

  const sendMessage = () => {
    if (inputMessage.trim()) {
      const encodedMessage = encodeURIComponent(inputMessage);
      window.open(`https://wa.me/${phoneNumber}?text=${encodedMessage}`, '_blank');
      setInputMessage('');
      setIsExpanded(false);
    }
  };

  return (
    <div className={styles.whatsappwidget}>
      {isExpanded ? (
        <div className={styles.chatcontainer}>
          <div className={styles.chatheader}>
            <h3>WhatsApp Chat</h3>
            <button 
              className={styles.closebtn}
              onClick={() => setIsExpanded(false)}
            >
              ×
            </button>
          </div>
          
          {chatMessage && (
            <div className={styles.initialmessage}>
              <p>{chatMessage}</p>
            </div>
          )}

          <div className={styles.chatinput}>
            <input
              type="text"
              value={inputMessage}
              onChange={(e) => setInputMessage(e.target.value)}
              placeholder="Escribe tu mensaje..."
              onKeyPress={(e) => e.key === 'Enter' && sendMessage()}
            />
            <button onClick={sendMessage} className={styles.sendbtn}>
              Enviar
            </button>
          </div>
        </div>
      ) : (
        <button 
          className={styles.whatsappicon}
          onClick={() => setIsExpanded(true)}
        >
          <FaWhatsapp size={40} />
        </button>
      )}
    </div>
  );
};

export default WhatsAppWidget;